exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../~/_core-js@2.6.9@core-js/library/modules/_wks-ext.js
// module id = 223
// module chunks = 0